module.exports = __webpack_public_path__ + "static/media/volume.d1d6e5ec.svg";